import { CollectionsListState } from '@src/types/Collection';

export function getCollectionIdToCategoryMap(collectionsList: CollectionsListState): Map<string, string> {
  const map = new Map<string, string>();
  collectionsList.forEach((category) => {
    category.list.forEach((collectionId) => map.set(collectionId, category.name));
  });
  return map;
}
